import React from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';

export const inviteLogSettings = {
	settingsForTable
};


function settingsForTable(){
	let columns = [
		{
			id: 'silo_code',
			Header: 'Silo Code',
			accessor: 'silo_code',
		 },      

		 {
			id: 'first_name',
			Header: 'First Name',
			accessor: 'first_name',
		 },      
		 {
		 id: 'last_name',
		 Header: 'Last Name',
		 accessor: 'last_name',
	  },      
	  {
		  id: 'email',
		  Header: 'Email',
		  accessor: 'email',
	   },
	   {
		   id: 'invited_at',
		   Header: 'Invited At',
		   accessor: 'invited_at',
		   Cell: props => <span>{moment(props.value).format('YYYY-MM-DD HH:mm:ss')}</span>
	   }
	   
	];
	return columns;
}
